import React, { useState } from 'react';
import { bool, func, string } from 'prop-types';

import Modal from './components/Modal';
import RatingModalContext from './contexts/RatingModalContext';
import { MODAL_MODE } from './constants';

function RatingModal({ onSubmit, onClose, visible, title, subTitle }) {
  const [modalMode, setModalMode] = useState(MODAL_MODE.FROM);

  const handleSubmit = data => {
    onSubmit(data);
    setModalMode(MODAL_MODE.THANKS_INFO);
    setTimeout(onClose, 3000);
  };

  return (
    <RatingModalContext.Provider
      value={{
        title,
        subTitle,
      }}
    >
      {visible && (
        <Modal mode={modalMode} onClose={onClose} onSubmit={handleSubmit} />
      )}
    </RatingModalContext.Provider>
  );
}

RatingModal.propTypes = {
  onSubmit: func.isRequired,
  onClose: func.isRequired,
  title: string.isRequired,
  subTitle: string.isRequired,
  visible: bool,
};

RatingModal.defaultProps = {
  visible: false,
};
export default RatingModal;
